module.exports = __webpack_public_path__ + "media/icons/offer-details-motocykle-9ab0e4b7.png";